module.exports = __webpack_public_path__ + "img/dk.6e485ae5.png";